import { NotifyHelper } from "../../../helpers/toast";
import { eXepLoaiChungChiActionObj } from "../../action-types/category/IXepLoaiChungChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xepLoaiChungChiActions = {
    ...generateActions(eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI"),
    ...generateActionForKey(eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}